import { render } from "./_form-textarea.vue?vue&type=template&id=884b691a"
import script from "./_form-textarea.vue?vue&type=script&lang=js"
export * from "./_form-textarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__